var render = function render(){var _vm=this,_c=_vm._self._c;return _c('StateAnalysis',{attrs:{"title":"健康评价报告","report":"jkReportHistories"}})
}
var staticRenderFns = []

export { render, staticRenderFns }